module.exports = __webpack_public_path__ + "static/media/play-boss-lose-5.2b866829.png";